export const createPassword = (payload: { password: string }) => ({
    type: '@saga/CREATE_PASSWORD',
    payload,
});
